module.exports = __webpack_public_path__ + "img/ticket.fd68e824.jpeg";